import axios from 'axios';
import { error } from 'console';
import { redirect } from 'react-router-dom';




const topApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});


topApi.interceptors.request.use(
    async (config) => {
        const token = await localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = "Bearer " + token;
        }
        config.headers['Access-Control-Allow-Origin'] = "*";
        config.headers["Access-Control-Allow-Headers"] = "Origin, X-Requested-With, Content-Type, Accept";
        return config;
    }
);

topApi.interceptors.response.use(
    async response => {
        if (response.status == 200) {
            const { token } = response.data;
            await localStorage.setItem('token', token);
        }
        if (response.status == 401 && response.data['error'] == 'Invalid token') {
            await localStorage.removeItem('token')
            window.location.href = '/login'
            return Promise.reject("Unauthorized");
        }
        return response
    },
    async error => {
        if (error.response.status === 401
            && (error.response.data['error'] == 'Invalid token' || error.response.data['error'] == 'Invalid session')) {
            await localStorage.removeItem('token')
            window.location.href = '/login'
            return Promise.reject("Unauthorized");
        }
        return Promise.reject(error);
    }
)



export default topApi;